
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface Paper {
  needs_ai_review?: boolean;
  needs_keywords?: boolean;
  needs_research_info?: boolean;
  keywords?: string[];
}

interface RemediationStatusBadgesProps {
  paper: Paper;
}

const RemediationStatusBadges: React.FC<RemediationStatusBadgesProps> = ({ paper }) => {
  return (
    <div className="flex flex-col gap-1">
      {paper.needs_ai_review && (
        <Badge variant="destructive" className="text-xs w-fit">
          Missing AI Review
        </Badge>
      )}
      {paper.needs_keywords && (
        <Badge variant="destructive" className="text-xs w-fit">
          Missing Keywords ({paper.keywords?.length || 0}/5)
        </Badge>
      )}
      {paper.needs_research_info && (
        <Badge variant="destructive" className="text-xs w-fit">
          Missing Research Info
        </Badge>
      )}
    </div>
  );
};

export default RemediationStatusBadges;
